import { Loader } from '@googlemaps/js-api-loader';

export default {
	gmap(key) {
	    return new Loader({
	        apiKey: key,
	        version: 'weekly',
	        libraries: ['places']
	    });
	}
};